<script>
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import Cart from '../../components/configure/Cart.svelte';
    import Collapsible from '../../components/Collapsible.svelte';
    import Channel from '../../components/configure/Channel.svelte';
    import PhoneAddon from '../../components/configure/PhoneAddon.svelte';
    import PhoneExtension from '../../components/configure/PhoneExtension.svelte';
    import PhonePortability from '../../components/configure/PhonePortability.svelte';
    import ServiceDescription from '../../components/configure/ServiceDescription.svelte';
    import TVExtension from '../../components/configure/TVExtension.svelte';
    import IzziMovilOffer from '../../components/movil/IzziMovilOffer.svelte';
    import { principalStreamersNames } from '../../Environment.svelte';
    import { store } from '../../Store.svelte';

    let showExtras = true;
    const vixName = principalStreamersNames.at(0);
    const netflix1SName = principalStreamersNames.at(5);
    const netflix2SName = principalStreamersNames.at(1);
    const netflix4SName = principalStreamersNames.at(2);
    const netflixAdds = principalStreamersNames.at(6);
    const maxName = principalStreamersNames.at(4);
    const maxOttName = principalStreamersNames.at(7);
    const maxAddsName = principalStreamersNames.at(8);
    const isSky = $store.requestedServices.isSky;
    const complementsStyle = `--dynamic-rgba: ${isSky ? 'rgba(4, 8, 255, 0.342)' : 'rgba(211, 23, 114, 0.1)'};
                              --dynamic-color: ${isSky ? '#000ff5' : '#d31772'};`;
    let canalesOcultar = [
        'Afizzionados M',
        'Afizzionados hospitality',
        'Hazlo HD Plus M',
    ];
    // let itemN4s = $store.requestedServices.product.extrasMap.ott.find(extra => extra.extra.extName == netflix4SName && extra.paqextVisible);
    // let itemN2s = $store.requestedServices.product.extrasMap.ott.find(extra => extra.extra.extName == netflix2SName && extra.paqextVisible);
    // let itemN1s = $store.requestedServices.product.extrasMap.ott.find(extra => extra.extra.extName == netflix1SName && extra.paqextVisible);
    let itemHHD =
        $store.requestedServices.product.extrasMap.canalesCarta.find(
            (extra) =>
                extra.extra.extName == 'Hazlo HD Plus M' && extra.paqextVisible
        ) ?? null;
    let itemNetFlix = undefined;

    if (
        $store.requestedServices.productId == null ||
        $store.requestedServices.productId.length == 0
    ) {
        navigate('/comparador', { replace: false });
    }

    function backHandler() {
        if (
            $store.requestedServices.product.productFamily != null &&
            $store.requestedServices.product.productFamily.indexOf(
                'izzinegocios'
            ) > -1
        ) {
            navigate('/comparador/negocios', { replace: false });
        } else {
            navigate(
                $store.requestedServices.isSky
                    ? '/comparador/sky'
                    : '/comparador',
                { replace: false }
            );
        }
        location.reload();
    }

    function hiddenAddonsClick(e) {
        var hiddenAddons = document.querySelector('.hidden-addons');
        hiddenAddons.classList.remove('hidden-addons');
        e.currentTarget.remove();
    }

    onMount(() => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
        $store.settings.location = { progress: 20, step: 1 };
        showExtras = false;
    });

    store.subscribe((value) => {
        itemNetFlix = $store.requestedServices.channelExtras.find((extra) =>
            [netflix1SName, netflix2SName, netflix4SName, netflixAdds].includes(
                extra.extra.extName
            )
        );
    });

    onMount(() => {
        try {
            if (
                $store.requestedServices.product.vel >= 150 &&
                $store.requestedServices.product.productFamily !=
                    'izzinegocios' &&
                $store.requestedServices.product.productFamily !=
                    'izzinegocios_3P' &&
                $store.requestedServices.isCombo &&
                $store.requestedServices.isNetflix
            ) {
                let id = $store.requestedServices.product.extrasMap.ott.find(
                    (ott) => ott.extra.extName === 'Netflix 2S M'
                );
                if (
                    !$store.requestedServices.channelExtras.some(
                        (item) => item.extId === id.extId
                    )
                )
                    document.getElementById(`addon_${id.extId}`).click();
            } else if (
                $store.requestedServices.product.vel <= 80 &&
                $store.requestedServices.product.productFamily !=
                    'izzinegocios' &&
                $store.requestedServices.product.productFamily !=
                    'izzinegocios_3P' &&
                $store.requestedServices.isCombo &&
                $store.requestedServices.isNetflix
            ) {
                let id = $store.requestedServices.product.extrasMap.ott.find(
                    (ott) => ott.extra.extName === 'Netflix_Add M'
                );
                if (
                    !$store.requestedServices.channelExtras.some(
                        (item) => item.extId === id.extId
                    )
                )
                    document.getElementById(`addon_${id.extId}`).click();
            }
        } catch (error) {
            console.warn('no hay netflix estandar');
        }
    });

    const getPaqExtVisible = () => {
        $store.requestedServices.product.extrasMap.ott.forEach((extraOtt) => {
            extraOtt.paqextVisible = extraOtt.paquetesVisible?.includes(
                $store.requestedServices.product.paqId
            );
        });
        $store.requestedServices.product.extrasMap.canalesCarta.forEach((extraCanal) => {
            extraCanal.paqextVisible = extraCanal.paquetesVisible?.includes(
                $store.requestedServices.product.paqId
            );
        });
    };

    getPaqExtVisible();
    $: isStreamingValid = !['movil'].includes(
        $store.requestedServices.product?.productFamily
    );
</script>

<div>
    <script>
        setTimeout(function () {
            try {
                window.document.dispatchEvent(
                    new Event('DOMContentLoaded', {
                        bubbles: true,
                        cancelable: true,
                    })
                );
            } catch (err) {}
        }, 1500);
    </script>
    <div class="pure-g">
        <div class="pure-u-1 sm-md-m-b-20">
            <h2 class="text-fs-26 m-b-25">Personaliza tu paquete</h2>
            <ServiceDescription />
            {#if ($store.settings.advancedConfigurationMode || (!$store.settings.advancedConfigurationMode && $store.requestedServices.product.extrasMap.extensiones.length > 0)) && !isSky}
                <div
                    class="panel {isSky
                        ? 'panel-sky'
                        : ''} panel--no-mobile m-b-25"
                >
                    {#if $store.settings.advancedConfigurationMode}
                        <div class="h2 text-fs-23 fw-semibold m-b-25">
                            Personaliza tu combo
                        </div>
                        <div class="addon-tabs">
                            <div class="addon-tab-controls__holder">
                                <div class="addon-tab-controls">
                                    {#if isStreamingValid}
                                        <a
                                            href="#tab_television"
                                            class="addon-tab-control {isStreamingValid
                                                ? 'addon-tab-control--active'
                                                : ''}"
                                            style={complementsStyle}
                                            >Televisión & Streaming</a
                                        >
                                    {/if}
                                    {#if $store.requestedServices.product.extrasMap.movil2_0}
                                        <a
                                            href="#tab_izzimovil"
                                            class="addon-tab-control {!isStreamingValid
                                                ? 'addon-tab-control--active'
                                                : ''}"
                                            style={complementsStyle}
                                            >izzi móvil</a
                                        >
                                    {/if}
                                    <!-- {#if !($store.requestedAddress.offnetCoverage || ['tv', 'movil'].includes($store.requestedServices.product?.productFamily))}
                                        <a
                                            href="#tab_telefonia"
                                            class="addon-tab-control"
                                            style={complementsStyle}
                                            >Telefonía</a
                                        >
                                    {/if} -->
                                </div>
                            </div>
                            <div class="addon-tab__content-holder">
                                <div
                                    id="tab_television"
                                    class="addon-tab-content {isStreamingValid
                                        ? 'addon-tab-content--active'
                                        : ''}"
                                >
                                    {#if ($store.requestedServices.product.nombreCode.includes('izzitvhd') || $store.requestedServices.product.nombreCode.includes('izzitv')) && !$store.requestedServices.product.nombreCode.includes('plus') && itemHHD}
                                        <div
                                            class="pure-g align-items-center m-b-25"
                                        >
                                            <div class="pure-u-2-3">
                                                <div
                                                    class="h2 text-fs-20 fw-semibold"
                                                >
                                                    Más contenido
                                                </div>
                                            </div>
                                            <div class="pure-u-1-3 text-right">
                                                <p class="m-b-0">Opcional</p>
                                            </div>
                                        </div>
                                        <Channel
                                            item={itemHHD}
                                            isDisable="false"
                                            isNetflix="false"
                                            netflix2s=""
                                            isHazloHDPlus="true"
                                        />
                                    {/if}

                                    {#if $store.requestedServices.product.extrasMap.ott.some((item) => item.paqextVisible)}
                                        <Collapsible
                                            title="Más diversión"
                                            subtitle="Opcional"
                                            ,
                                            isOpen={showExtras}
                                        >
                                            <div class="addons-grid">
                                                {#each $store.requestedServices.product.extrasMap.ott as item}
                                                    {#if item.paqextVisible}
                                                        {#if (item.extra.extName === vixName && $store.requestedServices.isVix) || ([netflix1SName, netflix2SName, netflix4SName, netflixAdds].includes(item.extra.extName) && $store.requestedServices.isNetflix) || ((item.extra.extName === maxName || item.extra.extName === maxOttName) && $store.requestedServices.isHBO && !$store.requestedServices.isHBOAdds)}
                                                            {#if itemNetFlix && itemNetFlix.extra.extName !== item.extra.extName && [netflix1SName, netflix2SName, netflix4SName, netflixAdds].includes(item.extra.extName)}
                                                                <Channel
                                                                    {item}
                                                                    isDisable="false"
                                                                    isSelected="false"
                                                                />
                                                            {:else}
                                                                <Channel
                                                                    {item}
                                                                    isDisable="true"
                                                                    isSelected="true"
                                                                />
                                                            {/if}
                                                        {:else if (item.extra.extName === maxName || item.extra.extName === maxOttName) && $store.requestedServices.isHBOAdds}
                                                            <Channel
                                                                {item}
                                                                isDisable="true"
                                                                isSelected="false"
                                                            />
                                                        {:else if item.extra.extName === 'ViX+ M'}
                                                            <Channel
                                                                {item}
                                                                isDisable="false"
                                                                isSelected="false"
                                                            />
                                                        {:else}
                                                            <Channel
                                                                {item}
                                                                isDisable="false"
                                                            />
                                                        {/if}
                                                    {:else if item.extra.extName === maxAddsName && $store.requestedServices.isHBOAdds}
                                                        <Channel
                                                            {item}
                                                            isDisable="true"
                                                            isSelected="true"
                                                        />
                                                    {/if}
                                                {/each}
                                            </div>
                                        </Collapsible>
                                    {/if}

                                    {#if $store.requestedServices.product.extrasMap.canalesPremium.some((item) => item.paqextVisible) || $store.requestedServices.product.extrasMap.canalesCarta.some((item) => item.paqextVisible && !($store.requestedServices.product.productFamily === 'tripleplay' && canalesOcultar.includes(item.extra.extName)) && item.extra.extName !== 'Hazlo HD Plus M')}
                                        <Collapsible
                                            title="Canales a la carta"
                                            subtitle="Opcional"
                                            ,
                                            isOpen={showExtras}
                                        >
                                            <div class="addons-grid">
                                                {#each $store.requestedServices.product.extrasMap.canalesPremium as item}
                                                    {#if item.paqextVisible}
                                                        <Channel
                                                            {item}
                                                            isDisable="false"
                                                        />
                                                    {/if}
                                                {/each}
                                                {#each $store.requestedServices.product.extrasMap.canalesCarta as item}
                                                    {#if item.paqextVisible && !($store.requestedServices.product.productFamily === 'tripleplay' && canalesOcultar.includes(item.extra.extName)) && item.extra.extName !== 'Hazlo HD Plus M'}
                                                        <Channel
                                                            {item}
                                                            isDisable="false"
                                                        />
                                                    {/if}
                                                {/each}
                                            </div>
                                        </Collapsible>
                                    {/if}

                                    <!-- <div class="pure-g align-items-center m-b-25">
                                        <div class="pure-u-2-3">
                                            <div
                                                class="h2 text-fs-20 fw-semibold"
                                            >
                                                {isSky
                                                    ? 'Agrega un equipo'
                                                    : 'Más TVs'}
                                            </div>
                                        </div>
                                        <div class="pure-u-1-3 text-right">
                                            <p class="m-b-0">Opcional</p>
                                        </div>
                                    </div>
                                    {#each $store.requestedServices.product.extrasMap.extensiones as item}
                                        {#if item.paqextVisible}
                                            <TVExtension {item} />
                                        {/if}
                                    {/each} -->
                                </div>
                                <div
                                    id="tab_izzimovil"
                                    class="addon-tab-content {!isStreamingValid
                                        ? 'addon-tab-content--active'
                                        : ''}"
                                >
                                    {#if isStreamingValid}
                                        <div
                                            class="pure-g align-items-center m-b-40"
                                        >
                                            <div
                                                class="pure-u-1 pure-u-md-19-24 sm-m-b-20"
                                            >
                                                <div
                                                    class="h2 text-fs-20 fw-semibold"
                                                >
                                                    Hey, ¡agrega un plan
                                                    ilimitado de telefonía
                                                    móvil!
                                                </div>
                                                <p class="m-b-0">
                                                    Descubre los planes
                                                    exclusivos que tenemos para
                                                    ti, desde <span
                                                        class="fw-semibold"
                                                        >$200.00 pesos</span
                                                    >
                                                </p>
                                            </div>
                                            <div
                                                class="pure-u-1 pure-u-md-5-24 text-right sm-only-text-left"
                                            >
                                                <p class="m-b-0">Opcional</p>
                                            </div>
                                        </div>
                                    {/if}
                                    <IzziMovilOffer />
                                </div>
                                <div
                                    id="tab_telefonia"
                                    class="addon-tab-content"
                                >
                                    {#each $store.requestedServices.product.extrasMap.telefono as item}
                                        {#if item.paqextVisible}
                                            <PhoneAddon {item} />
                                        {/if}
                                    {/each}
                                    <PhonePortability />
                                    <hr class="m-b-25" />
                                    <div class="pure-g">
                                        {#each $store.requestedServices.product.extrasMap.telefonoExtensiones as item}
                                            {#if item.paqextVisible}
                                                <PhoneExtension {item} />
                                            {/if}
                                        {/each}
                                    </div>
                                </div>
                            </div>
                        </div>
                    {:else if $store.requestedServices.product.extrasMap.extensiones.length > 0}
                        <div class="pure-g align-items-center m-b-25">
                            <div class="pure-u-2-3">
                                <div
                                    class="h2 text-fs-20 {isSky
                                        ? ''
                                        : 'fw-semibold'}"
                                >
                                    {isSky
                                        ? 'Agrega un equipo'
                                        : 'Complementa tu diversión'}
                                </div>
                            </div>
                            <div class="pure-u-1-3 text-right">
                                <p class="m-b-0">Opcional</p>
                            </div>
                        </div>
                        <!--  {#each $store.requestedServices.product.extrasMap.extensiones as item}
                            {#if item.paqextVisible}
                                <TVExtension {item} />
                            {/if}
                        {/each} -->
                    {/if}
                </div>
            {/if}
            {#if isSky}
                {#each $store.requestedServices.product.extrasMap.ott as item}
                    {#if item.extra.extName === vixName && $store.requestedServices.isVix}
                        <Channel {item} isDisable="true" isSelected="true" />
                    {/if}
                {/each}
                {#each $store.requestedServices.product.extrasMap.canalesCarta as item}
                    {#if item.extra.extName === 'Sky Prepago Lealtad'}
                        <Channel {item} isDisable="true" isSelected="true" />
                    {/if}
                {/each}
            {/if}
            <div class="d-flex align-items-center justify-content-between">
                <div
                    on:click={backHandler}
                    on:keypress={backHandler}
                    class="back-link"
                >
                    <svg class="icon" aria-hidden="true"
                        ><use
                            xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                        /></svg
                    >
                    <span>atrás</span>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .back-link {
        cursor: pointer;
    }
    .panel-sky {
        padding: 30px;
    }
</style>
